import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

export default function Logo({
  sizeClass = "w-[40px] h-[40px]",
  textSizeClass = "text-2xl",
  ...props
}) {
  return (
    <div className='flex items-center gap-3 relative' {...props}>
      <StaticImage 
        alt="pipelime logo"
        src="../../images/logo.png"
        className={`transition-all ${sizeClass}`}
      />
      <h2 className={`transition-all hidden lg:inline-block ${textSizeClass}`}>PipeLime</h2>
    </div>
  )
}
